module.exports = __webpack_public_path__ + "static/bilaal-cover-cadac2d17c6d89fa77fda7d79c556f84.png";